import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subscription } from 'rxjs';
import { ConfirmationModalConfig } from '../../../shared/components/confirmation-modal/confirmation-modal.component';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { DstAdminDeleteModalService } from './dst-admin-delete-modal.service';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  generalConfigFromGlobal,
  hydratedGlobalParams,
  normalizeFilterParams,
  rowPayloadFromActiveScreen,
} from '../../../shared/workspace-element-context';

@Component({
    selector: 'gtw-dst-admin-delete-modal',
    templateUrl: './dst-admin-delete-modal.component.html',
    styleUrls: ['./dst-admin-delete-modal.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class DstAdminDeleteModalComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);

  private readonly subs = new Subscription();

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  filterParams: any = {};
  rowData: any = {};
  @Input('modal-context') modalContext = '';

  baseURLs: any = { admin: '', api: '', custom: '' };
  globalService: any = {};
  GENERAL_CONFIG: any = {};
  modalConfig: ConfirmationModalConfig = {
    title: 'Confirm Delete',
    message: 'Are you sure you want to delete?',
    iconClass: 'fa fa-trash',
    iconColor: 'txt-color-orange-dark',
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
    confirmButtonClass: 'btn-danger',
    cancelButtonClass: 'btn-default',
    showCancelButton: true,
    showConfirmButton: true,
    animationClass: 'animated fadeIn fast',
    loading: false,
    loadingText: 'Processing...'
  };
  showModal = true;

  private isInitialized = false;

  constructor(
    private gtwSnackbarService: GtwSnackbarService,
    private dstAdminDeleteModalService: DstAdminDeleteModalService,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService,
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.subs.add(
      this.gtwGlobal.globalParamsChanged$.subscribe(() => {
        this.applyWorkspaceContext();
      })
    );
    this.subs.add(
      this.gtwWorkspace.setTabActive.subscribe(() => {
        this.applyWorkspaceContext();
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    this.GENERAL_CONFIG = generalConfigFromGlobal(this.gtwGlobal);
    this.baseURLs = this.GENERAL_CONFIG;
    this.globalService = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace);
    this.filterParams = normalizeFilterParams(activeScreen);
    this.rowData = rowPayloadFromActiveScreen(activeScreen);
    this.tryInit();
  }

  private tryInit(): void {
    if (this.isInitialized) return;
    if (!this.globalService || !this.GENERAL_CONFIG) return;
    this.isInitialized = true;
  }

  onConfirm(): void {
    this.modalConfig.loading = true;
    const baseUrl = this.GENERAL_CONFIG?.base_url || '';
    this.dstAdminDeleteModalService.delete(baseUrl, this.globalService, this.filterParams, this.rowData, this.modalContext).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (res: any) => {
        this.modalConfig.loading = false;
        if (res?.callSuccess === '1' && res?.errorMessage === 'null') {
          this.gtwSnackbarService.openSnackBar('Deleted successfully.', 'gtw-snackbar--green');
          this.requestGridUpdate.emit('refresh');
        } else {
          this.gtwSnackbarService.openSnackBar(res?.errorMessage || 'Delete failed.', 'gtw-snackbar--red');
        }
      },
      () => {
        this.modalConfig.loading = false;
        this.gtwSnackbarService.openSnackBar('Error during delete. Please try again.', 'gtw-snackbar--red');
      }
    );
  }

  onCancel(): void {
    this.requestGridUpdate.emit('cancel');
  }
}
